import { render, staticRenderFns } from "./right-fixed.vue?vue&type=template&id=4261bd2c&scoped=true&"
import script from "./right-fixed.vue?vue&type=script&lang=js&"
export * from "./right-fixed.vue?vue&type=script&lang=js&"
import style0 from "./right-fixed.vue?vue&type=style&index=0&id=4261bd2c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4261bd2c",
  null
  
)

export default component.exports